
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import mydtList from '@/crowd_fund/mydtList'
import zcitem from '@/crowd_fund/zcitem'
import myhelprecord from '@/crowd_fund/myhelprecord'
import compentList from '@/crowd_fund/compentList'
import conpentListnew from '@/crowd_fund/compentListnew'
import headerBackTitle from '@/components/header/headerBackTitle'

export default {
components:{
myhelprecord,
zcitem,
mydtList,
compentList,
conpentListnew,
headerBackTitle,
Tab,
TabItem
},
data () {
return {
provinceTop:this.$route.query.isProvince?'47px':'',
isProvince:this.$route.query.isProvince,
iswxlink:this.$route.query.iswxlink, //众筹跳转列表
zcdata : '',
zcuserid:'',
zctoken:'',
code:'',
zcnickname:'',
zcheadimgurl:'',
typeIndex:sessionStorage.getItem("typeIndex") == 1?1:0,
myIndex: sessionStorage.getItem("myIndex") == 1?1:0,
listTab: ['扶贫公募', '我的'],
activeTab:'扶贫公募',
myTab:[
{
name:'募捐记录',
index:0
},{
name:'一起捐',
index:1
}],
epId:'',
isPublish:'',
isFromZcDetail:true,
}
},
methods:{
mytabSwitch(index,item) {
this.myIndex = index
},
tabSwitch(index,item) {
this.activeTab = item
this.typeIndex = index
},
goQKL (data) {
window.location.href=this.QKL_URL+data
},
zcList () {
let data={
acr010: "",
acr012: "",
pageIndex: 0,
pageSize: 50,
xmpx: 1
}
this.$https.post(this.BASE_URL+"cfs/zc/project/getfpzhongchouList",data)
.then(res => {
this.zcdata = res.data.data.data;
console.log(res.data.data.data);
})
.catch(function(err) {
console.log(err);
})
},
wxchat () {
let self = this;
this.$https.get(this.BASE_URL+'uts/invitationCode/wxAuthorization',{params:{
'code':this.code
}}).then( data => {
let res = data.data
if(res.code == 'UTSI0000'){
self.zcuserid = res.data.userId;
self.zctoken = res.data.logintoken;
self.zcnickname = res.data.nickname
self.zcheadimgurl = res.data.headimgurl

localStorage.setItem('zcuserid',res.data.userId);
localStorage.setItem('zcopenid',res.data.openid);
localStorage.setItem('zcunionid',res.data.unionid);
localStorage.setItem('zcnickname',res.data.nickname);
localStorage.setItem('zcheadimgurl',res.data.headimgurl);
this.isCompany(self.zcuserid)
}else{
this.isCompany(this.G("zcuserid"))
}
})
},
isCompany(userid) {
let data={
userId: userid

}
this.$https.post(this.BASE_URL+"grd/groupDonation/isAuthorized",
data
)
.then(res => {
if(res.data.code == "GRDI0000") {
this.isPublish = true
this.epId = res.data.data
}else if(res.data.code == "GRD06004"){
this.isPublish = true
this.epId = res.data.data
}else{
this.isPublish = false
}
})
.catch(function(err) {
console.log(err);
})
},
getUrlParamURLysas(name) {
var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
var r = window.location.search.substr(1).match(reg);
if (r != null){
return unescape(r[2]);
}
return "";
}
},
mounted() {

if(this.isWeixinCient()){

if(this.iswxlink == 1) {
this.zcuserid = localStorage.getItem('zcuserid');
this.zcnickname = localStorage.getItem('zcnickname');
this.zctoken = localStorage.getItem('zctoken')
}
this.code = this.getUrlParamURLysas('code');
if(sessionStorage.getItem("isFromDetail")){
this.zcuserid = localStorage.getItem('zcuserid');
this.zcnickname = localStorage.getItem('zcnickname');
this.zctoken = null
this.isCompany(this.zcuserid)
}else{
this.wxchat();

}

}else{
localStorage.setItem('zcnickname',this.$route.params.zcnickname);
localStorage.setItem('zcheadimgurl',this.$route.query.headImage);
this.zcheadimgurl = this.$route.query.headImage;
this.zcnickname = this.$route.params.zcnickname
this.zcuserid = this.$route.params.zcuserid;
this.zctoken = this.$route.params.zctoken;
}
},
created() {
localStorage.setItem('anlpbaFlag','2')
console.log(window.location.href,'这是列表的地址');





















localStorage.setItem('isProvince',this.isProvince)
this.zcList();
console.log(window.location.href,'列表页的地址',this.$route.query)
},
watch :{
$route(to,from){
console.log(to.path,'3333333333333333333333333333');
}
},
beforeRouteEnter(to, from, next) {
if(from.name == 'zcprojectDetail'){
sessionStorage.setItem("isFromDetail",true)
sessionStorage.setItem("myIndex",0)
next()
}else if(from.name == 'dTDetail'){
sessionStorage.setItem("isFromDetail",true)
sessionStorage.setItem("myIndex",1) 
sessionStorage.setItem("typeIndex",1)
next()
}else if(from.name == 'zcrecdetail' || from.name == 'zchelphe' || from.name == 'zccertificate'){
sessionStorage.setItem("isFromDetail",true)
sessionStorage.setItem("myIndex",0) 
sessionStorage.setItem("typeIndex",1)
next()
}else{
next()
}
},
}



// WEBPACK FOOTER //
// ./src/crowd_fund/projectList.vue